(function(){
    'use strict';

    angular
    .module('appback')
    .controller('GastosController', GastosController)
 
    GastosController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function GastosController($http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
       	//console.log("hola");
    }
  
})();